/** Projects Web-owned compact result cards. Layout is supplied alongside the cards, never inferred from their content. */
import type { ShopifyResultTreatmentCard } from '@testfeed/shopify-contracts'
import { ServerResultCard } from './ServerResultCard'
import './ServerResultCards.css'

export function ServerResultCards({
  cards,
  layout,
  onSelectTab,
}: {
  cards: ShopifyResultTreatmentCard[]
  layout: 'columns' | 'rows'
  onSelectTab?: (tab: string) => void
}) {
  return (
    <div className={`tf-server-results-grid tf-server-results-grid--${layout}`}>
      {cards.map((card) => (
        <ServerResultCard
          key={card.armId}
          card={card}
          actions={<ReactionAction card={card} onSelectTab={onSelectTab} />}
        />
      ))}
    </div>
  )
}
function ReactionAction({
  card,
  onSelectTab,
}: {
  card: ShopifyResultTreatmentCard
  onSelectTab?: (tab: string) => void
}) {
  const action = card.reactionAction
  if (!action || !onSelectTab) return null
  return <s-button onClick={() => onSelectTab(action.tabId)}>{action.label}</s-button>
}
